import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function CTASection() {
  return <section id="comprar" className="py-24 md:py-40 px-6 bg-cream-100 relative overflow-hidden" data-id="element-45">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-terracotta/5 rounded-full blur-3xl pointer-events-none" data-id="element-46" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-47">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-8" data-id="element-48">
          La decisión real
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-charcoal-light mb-12 leading-relaxed" data-id="element-49">
          No es "comprar un PDF". Es decidir que tu cuerpo tenga un plan antes
          de que tu día te pase por arriba.
          <br data-id="element-50" />
          <br data-id="element-51" />
          <span className="font-serif italic text-charcoal" data-id="element-52">
            Porque la próxima vez que sientas ese pico… vos ya vas a saber qué
            hacer con tus manos.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-53">
          {/* Pricing */}
          <div className="mb-8" data-id="element-54">
            <div className="inline-flex items-center gap-2 bg-terracotta/10 text-terracotta-dark font-medium text-sm px-4 py-1.5 rounded-full mb-4" data-id="element-55">
              <span data-id="element-56">50% OFF</span>
            </div>
            <div className="flex items-center justify-center gap-3" data-id="element-57">
              <span className="text-charcoal-light line-through text-xl md:text-2xl" data-id="element-58">
                $14.310
              </span>
              <span className="text-4xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-59">
                $9.540
              </span>
            </div>
          </div>

          <CTAButton text="Quiero MIS MANOS, MI CALMA" href="https://infoproductosx10.com/cart/47068218392754:1" size="large" className="shadow-2xl shadow-terracotta/30" data-id="element-60" />
          <p className="mt-6 text-sm text-charcoal-light opacity-70" data-id="element-61">
            Acceso inmediato • Pago seguro
          </p>
        </motion.div>
      </div>
    </section>;
}